import GLightbox from 'glightbox';
export function initLightBox()
{
    GLightbox({
        touchNavigation: true,
        loop: true,
    });
}